module.exports = "<template> <div class=sio-view-header> <h1>${title|t}</h1> <p if.bind=subtitle>${subtitle|t}</p> </div> </template>";